import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d7ef637"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "sidebar-scroll",
  id: "mySidebar"
}
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = {
  class: "menu",
  ref: "element"
}
const _hoisted_4 = { id: "nav" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "bi bi-caret-right-fill"
}
const _hoisted_7 = {
  key: 1,
  class: "bi bi-caret-down-fill"
}
const _hoisted_8 = { class: "MenuStyle" }
const _hoisted_9 = {
  key: 0,
  class: "second-dropdown"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "MenuStyle" }, "SCAN-PC", -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "MenuStyle" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "MenuStyle" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "MenuStyle" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "MenuStyle" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "MenuStyle" }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "MenuStyle" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.isLoading)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("a", {
      href: "#",
      id: "openNav",
      class: "openmenu",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openmenu()))
    }, "☰"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: "#",
            class: "closemenu",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closemenu()))
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("nav", _hoisted_4, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.state.items[0], (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "first-dropdown",
                  key: index
                }, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => ($setup.toggleOpen(index)),
                    style: {"display":"flex","align-items":"center"}
                  }, [
                    ($setup.store.state.isOpen[0][index] === false)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                      : (_openBlock(), _createElementBlock("i", _hoisted_7)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_5),
                  ($setup.store.state.isOpen[0][index] === true)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (subMenuItem, subMenuIndex) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: subMenuIndex,
                            style: {"height":"100%","width":"220px"}
                          }, [
                            _createCommentVNode(" MDCR メインメニューにリンクがある場合、別のウィンドウで表示修正 Start "),
                            (item.name == 'Admin' || item.name == 'General Function' || item.id == 'MT0010' || (item.id == 'MT0001' && subMenuItem.id == 'MM0095'))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                  (subMenuItem.url == 'PcDownload')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        style: {"display":"flex","align-items":"center","cursor":"pointer"},
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goToPC()))
                                      }, _hoisted_12))
                                    : _createCommentVNode("v-if", true),
                                  (subMenuItem.url == 'KDP_SalesNote')
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        style: {"display":"flex","align-items":"center","cursor":"pointer"},
                                        onClick: ($event: any) => ($setup.goToSalesNote(subMenuItem))
                                      }, [
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(subMenuItem.name), 1 /* TEXT */)
                                      ], 8 /* PROPS */, _hoisted_13))
                                    : (subMenuItem.name == 'SCAN-MX' ||
                        subMenuItem.name == 'SCAN-FD' || subMenuItem.name == 'SCAN-FD Option for Manufacturer'
                        )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                          _createCommentVNode(" 2023/05/12 MDCR 修正 start(SCAN-FD,SCAN-MXメニューのジャンプ対応) "),
                                          _createElementVNode("span", null, [
                                            _createElementVNode("span", {
                                              style: {"display":"flex","align-items":"center","cursor":"pointer"},
                                              onClick: ($event: any) => ($setup.MenuOpenWindow(subMenuItem))
                                            }, [
                                              _createElementVNode("span", _hoisted_16, _toDisplayString(subMenuItem.name), 1 /* TEXT */)
                                            ], 8 /* PROPS */, _hoisted_15)
                                          ])
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                      : (subMenuItem.id == 'MM0084')
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 3,
                                            onClick: ($event: any) => ($setup.checkIsLoginAdmin(subMenuItem)),
                                            style: {"display":"flex","lign-items":"center","cursor":"pointer"}
                                          }, [
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(subMenuItem.name), 1 /* TEXT */)
                                          ], 8 /* PROPS */, _hoisted_17))
                                        : (_openBlock(), _createElementBlock("span", {
                                            key: 4,
                                            style: {"display":"flex","align-items":"center","cursor":"pointer"},
                                            onClick: ($event: any) => ($setup.showPage(subMenuItem))
                                          }, [
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(subMenuItem.name), 1 /* TEXT */)
                                          ], 8 /* PROPS */, _hoisted_19))
                                ]))
                              : ((subMenuItem.url != null || subMenuItem.url != '') && subMenuItem.url != 'None')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                    _createCommentVNode(" MDCR メインメニューにリンクがある場合、別のウィンドウで表示修正 End "),
                                    _createElementVNode("span", {
                                      style: {"display":"flex","align-items":"center","cursor":"pointer"},
                                      onClick: ($event: any) => ($setup.MenuOpenWindow(subMenuItem))
                                    }, [
                                      _createElementVNode("span", _hoisted_23, _toDisplayString(subMenuItem.name), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_22)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                    _createElementVNode("span", {
                                      style: {"display":"flex","align-items":"center"},
                                      onClick: ($event: any) => ($setup.showPage(subMenuItem))
                                    }, [
                                      _createElementVNode("span", _hoisted_26, _toDisplayString(subMenuItem.name), 1 /* TEXT */),
                                      _hoisted_27
                                    ], 8 /* PROPS */, _hoisted_25)
                                  ]))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ], 512 /* NEED_PATCH */)
      ])
    ])
  ]))
}